export const facebookLoginAppId = window.REACT_APP_FACEBOOK_APP_ID || '607402994957828';
export const facebookLoginScope = 'public_profile,email';
export const facebookBusinessLoginAppId = '824396629989622' || window.REACT_APP_FACEBOOK_BUSINESS_APP_ID;
export const facebookBusinessLoginConfigId = '1516114799708249' ||window.REACT_APP_FACEBOOK_BUSINESS_CONFIG_ID;